export default "__VITE_ASSET__B$LB5kt0__"